module.exports = __webpack_public_path__ + "57a5f178c5ff073f45b0c0feef736bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/playbookSketch.png
// module id = 1093
// module chunks = 0